import { domainIds } from '../../StaticData/Domains';
import { PlacementModes } from './PlacementModes';
import { PaceTypes } from '../../../../Common/Partials/StaticData/PaceTypes';
import { ExecutionTypes } from '../../../../Common/Partials/StaticData/ExecutionTypes';

const DefaultValues = {
  domains: [domainIds.tmn_tag],
  dynamic_placement_mode: PlacementModes.merge,
  execution_type: ExecutionTypes.all,
  pace_type: PaceTypes.traffic
};

export default DefaultValues;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/StaticData/DefaultValues.tsx